import { jsx as _jsx } from "react/jsx-runtime";
import { BaseContainedButton } from './styleds/ContainedButton.styled';
import { BaseGhostButton } from './styleds/GhostButton.styled';
import { BaseOutlinedButton } from './styleds/OutlinedButton.styled';
const BaseButton = ({ variant, ...otherProps }) => {
    if (variant === 'ghost') {
        return _jsx(BaseGhostButton, { ...otherProps });
    }
    if (variant === 'outlined') {
        return _jsx(BaseOutlinedButton, { ...otherProps });
    }
    return _jsx(BaseContainedButton, { ...otherProps });
};
export default BaseButton;
